var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrowdsourcing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    height: "256px",
    width: "256px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-48.76 -48.76 585.11 585.11",
    xmlSpace: "preserve",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("rect", {
    x: -48.76,
    y: -48.76,
    width: 585.11,
    height: 585.11,
    rx: 0,
    fill: "#000000",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 82.573,
    cy: 294.182,
    r: 60.937
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 243.771,
    cy: 294.182,
    r: 60.937
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.948,
    cy: 294.182,
    r: 60.937
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.948,361.267c-39.518,0-72.435,26.661-80.567,62.404c-8.111-35.635-41.049-62.404-80.61-62.404 c-39.539,0-72.478,26.661-80.567,62.404c-8.132-35.635-41.071-62.404-80.61-62.404C36.972,361.267,0,396.816,0,440.669v44.091 h487.586v-44.091C487.586,396.816,450.592,361.267,404.948,361.267L404.948,361.267z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.719,115.814c-33.629,0-60.873,27.309-60.873,60.937s27.287,60.959,60.873,60.959 c33.737,0,60.981-27.33,60.981-60.959S359.456,115.814,325.719,115.814z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.781,
    cy: 176.773,
    r: 60.959
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 243.793,
    cy: 63.763,
    r: 60.937
  })), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null)))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrowdsourcing);
export default __webpack_public_path__ + "static/media/Crowdsourcing.314380aa8634f27eb32951ff6e4e85bf.svg";
export { ForwardRef as ReactComponent };